module.exports = __webpack_public_path__ + "img/10.5833dd10.png";